angular
  .module("ticketco/common")
  .filter("territoryCurrency", territoryCurrency);

function territoryCurrency($filter, Locale) {
  return function (amount, currencySymbol, fractionSize) {
    currencySymbol = currencySymbol || Locale.getCurrentCurrencySymbol();

    return $filter("currency")(amount, currencySymbol);
  };
}
